import * as React from 'react';
import {useEffect} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import Top from "../Top";

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import {styled} from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import {Typography} from '@mui/material';
import {FormContainer, TextFieldElement} from "react-hook-form-mui";
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import WcIcon from '@mui/icons-material/Wc';
import FaceIcon from '@mui/icons-material/Face';
import Face4Icon from '@mui/icons-material/Face4';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import StateMissingFallback from "../../components/StateMissingFallback";
import { isBirthDate } from "../../utils/niceAuth";

const typeMemberProfile = {
  id: '', name: '', birthDate: '', cusId: '', phone: '', address: '', buildingNum: '', companyId: ''
  ,email: '', zipCode: '', beforePassword: '', password: '', 
  height: '', weight: '',
  interest_disease: '', is_medicine: '', work_strength: ''
};

const UserJoinPrivate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userInfo = { ...location.state };
  const [memberProfile, setMemberProfile] = React.useState(typeMemberProfile);
  const [alignment, setAlignment] = React.useState('1');
  
  useEffect(() => {
    setMemberProfile(userInfo);
  }, []);
  
  
  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string | null,
  ) => {
    if (newAlignment !== null) {
      setAlignment(newAlignment);
    }
  };
  
  // 회원 추가정보를 받기 위한 화면으로 이동
  async function handleSaveUser(data :any){
    // 생년월일은 본인인증에서 받은 YYYYMMDD 다. 값이 없거나 형식이 어긋나면
    // substring 이 조용히 '--' 같은 값을 만들어 그대로 저장된다.
    // (예전에는 값이 아예 없을 때 여기서 TypeError 가 나 버튼이 먹지 않았다)
    const rawBirthDate = String(data.birthDate ?? '');
    if (!isBirthDate(rawBirthDate)) {
      alert('본인인증 정보를 확인하지 못했습니다.\n처음부터 다시 진행해 주세요.');
      navigate('/Join/Join', { replace: true });
      return;
    }

    const updatedProfile = {
      ...memberProfile,
      name: data.userName,
      birthDate: `${rawBirthDate.substring(0, 4)}-${rawBirthDate.substring(4, 6)}-${rawBirthDate.substring(6, 8)}`,
      sex: alignment !== '0'
    };

    navigate('/Join/UserJoinContact', {state: updatedProfile});
  }

  

  // 앞 단계(UserJoin)를 거치지 않고 이 주소로 바로 들어오면 넘겨받은 값이 없다.
  // 앱을 백그라운드로 보냈다가 OS 가 WebView 를 되살릴 때도 그렇다.
  // 빈 폼을 보여주고 진행시키면 이름·생년월일 없이 가입이 이어진다.
  if (!location.state) {
    return (
      <StateMissingFallback
        title="회원 가입"
        message={'본인인증 정보가 없습니다.\n처음부터 다시 진행해 주세요.'}
        actionLabel="회원 가입 처음으로"
        to="/Join/Join"
      />
    );
  }

  return (
    <Container sx={Logbg}>
      <Top title="회원 가입" />

      <Stack direction={'column'} sx={{ justifyContent: 'center', alignContent: 'center' }}>
        <FormContainer
          values={{ userName: memberProfile.name, birthDate: memberProfile.birthDate }}
          onSuccess={data => handleSaveUser(data)}
        >

          <Card sx={{ p: '0px 20px 30px 20px', bgcolor:'#fff' }}>
            <Divider  sx={{fontSize:18, mb:2, mt:2.5, fontWeight:700}}>개인 정보</Divider>

            <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 2, width: '100%' }}>
              <AssignmentIndIcon sx={profileIcon} />
              <TextFieldElement
                name="userName"
                id="input-userName" label="이름" variant="standard"
                fullWidth
                inputProps={{ readOnly: true }}
                sx={loginField}
              />
              {/*<Button sx={{ fontSize: 12, minWidth: 70, border: '1px solid #ed6c02', borderRadius: 20, color: '#ed6c02', bgcolor: '#ed6c0214', fontWeight: 700, p: .5 }}>
                본인인증
              </Button>*/}
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 2, width: '100%' }}>
              <CalendarMonthIcon sx={profileIcon} />
              <TextFieldElement
                name="birthDate"
                id="input-birth" label="생년월일" variant="standard"
                fullWidth
                inputProps={{ readOnly: true }}
                sx={loginField}
              />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 2, width: '100%' }}>
              <WcIcon sx={profileIcon} />
              <Stack direction={'row'} alignItems={'baseline'} sx={{borderBottom:'1px solid #bbb', width:'100%'}}>
                <Typography gutterBottom sx={{ color: '#888', fontSize: 16, }}>성별</Typography>
                <ToggleButtonGroup
                  color="warning"
                  size="small"
                  value={alignment}
                  exclusive
                  onChange={handleChange}
                  aria-label="sex"
                  sx={{width:'75%', ml:'auto'}}
                >
                  <ToggleButton value="1" fullWidth><FaceIcon /></ToggleButton>
                  <ToggleButton value="0" fullWidth><Face4Icon /></ToggleButton>
                </ToggleButtonGroup>
              </Stack>
            </Box>

          </Card>

          <Box sx={{ p: '10px 0px 30px 0px' }}>
            <Stack direction="row" justifyContent="center" alignItems="center" spacing={0} sx={{ mt: 3, bgcolor: '#ffb068', borderRadius: '20px' }}>
              <CareButton variant="contained" type={'submit'}>
                다음
              </CareButton>
            </Stack>
          </Box>
        </FormContainer>

      </Stack>
    </Container>

  );
}

const profileIcon = {
  color: '#888', mr: 1, my: 0.5, fontSize: 20
}

const CareButton = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  fontWeight: 700,
  padding: '10px 30px',
  lineHeight: 1.5,
  backgroundColor: '#EF8322',
  borderColor: '#EF8322',
  borderRadius: '20px',
  width: '100%',
  '&:hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  '&:focus': {
    boxShadow: 'none',
  },
});

const loginField = {
  '& input': {
    fontSize: 16
  },
  '& label': {
    color: '#888',
    fontSize: 16
  },
  '& label.Mui-focused': {
    color: '#ef8322',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#ef8322',
  },
  '& .MuiInputBase-root:before': {
    borderBottomColor: '#bbb',
  }
};

const Logbg = {
  bgcolor: '#f6f6f6',
  height: '100%',
  minHeight: '100vh',
  pb: 4,
  minWidth: '320px',
  pt: 10,
}

export default UserJoinPrivate;